import { gql } from "@apollo/client";

export const UPDATE_ELIGIBILITY_MUTATION = gql`
  mutation UpdateEligibilityMutation($data: EligibilityUpdateData!) {
    updateEligibility(data: $data) {
      id
      orgId
      situation
      autoScreen
    }
  }
`;
